import React, { useState } from "react";

const Paragraph = ({ children }: { children: React.ReactNode }) => {
  return <p style={{ color: "rgb(165, 194, 97)" }}>{children}</p>;
};

export default Paragraph;
